<script lang="ts" setup>
import type { PopoverProps } from '@nuxt/ui'

withDefaults(
  defineProps<{
    hasStyle?: boolean
    hasArrow?: boolean
    isDisabled?: boolean
    content?: PopoverProps['content']
  }>(),
  { hasStyle: true, content: () => ({ side: 'top', align: 'center' }) }
)
</script>

<template>
  <UPopover
    v-if="!isDisabled"
    mode="hover"
    :arrow="
      hasArrow
        ? {
            width: 12,
            height: 6,
            rounded: true
          }
        : false
    "
    class="w-fit"
    :content="content"
    :ui="{
      arrow: 'fill-muted',
      content:
        'z-1120 max-w-xs text-xs px-2 py-1 bg-muted rounded text-black-600 ring shadow-sm'
    }"
  >
    <span
      :class="{
        '*:underline *:decoration-dashed *:underline-offset-2 *:decoration-1':
          hasStyle
      }"
    >
      <slot />
    </span>

    <template #content>
      <slot name="tooltip" />
    </template>
  </UPopover>

  <slot v-else />
</template>
